import React, { useCallback } from 'react';
import _ from 'lodash';
import { useScheduleFilter } from '../../../../../../data/hooks/schedule/useScheduleFilter';
import tinycolor2 from 'tinycolor2';
import HeaderFilterSelection from '../../../../../elements/HeaderFilterSelection';

function ScheduleFilterSelection(props) {
    const { eventId } = props,
        [filter, , , categories] = useScheduleFilter(eventId);

    const handleClearFilter = useCallback(() => {
            app.history.replace('..');
        }, [eventId]),
        handleTagClicked = useCallback(
            (cat, option) => {
                app.history.push('./filter')
            },
            [eventId]
        );

    const tags = _(filter.categories)
        .map((options, cat) => {
            return _(options || [])
                .map((option) => _(categories).chain().find({ name: cat }).get('options').find({ name: option }).value())
                .compact() // remove empty results (for when the option doesn't exist)
                .map((option) => ({
                    option,
                    label: option.name,
                    color: option.color,
                }))
                .value();
        })
        .flatten()
        .value();

    return <HeaderFilterSelection tags={tags} onClearButtonClick={handleClearFilter} onClick={handleTagClicked} />;
}

export default ScheduleFilterSelection;
